export default "__VITE_ASSET__87c8623b__"